import { Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import ReferenceDataCreateScreen from "../../../components/screens/ReferenceDataCreateScreen/ReferenceDataCreateScreen";
import ReferenceDataListScreen from "../../../components/screens/ReferenceDataListScreen/ReferenceDataListScreen";
import ReferenceListScreen from "../../../components/screens/ReferenceListScreen/ReferenceListScreen";
import LandingPageScreen from "../../components/landing-page/LandingPageScreen/LandingPageScreen";
import DatabaseCreateScreen from "../../components/pages/DatabaseCreateScreen/DatabaseCreateScreen";
import DatabaseEditScreen from "../../components/pages/DatabaseCreateScreen/DatabaseEditScreen";
import DatabaseDataCreatePage from "../../components/pages/DatabaseDataCreatePage";
import DatabaseDataEditPage from "../../components/pages/DatabaseDataEditPage";
import DatabaseDataListPage from "../../components/pages/DatabaseDataListPage";
import DatabaseListPage from "../../components/pages/DatabaseListPage";
import DatabaseViewPage from "../../components/pages/DatabaseViewPage";
import DeveloperScreen from "../../components/pages/DeveloperScreen/DeveloperScreen";
import ErrorNotFoundScreen from "../../components/pages/ErrorNotFoundScreen/ErrorNotFoundScreen";
import ErrorUnexpectedScreen from "../../components/pages/ErrorUnexpectedScreen/ErrorUnexpectedScreen";
import HomeScreen from "../../components/pages/HomeScreen/HomeScreen";
import ImportDataPage from "../../components/pages/ImportDataPage";
import JournalsScreen from "../../components/pages/JournalsScreen/JournalsScreen";
import OrganizationCreatePage from "../../components/pages/OrganizationCreatePage";
import OrganizationEditPage from "../../components/pages/OrganizationEditPage";
import OrganizationListPage from "../../components/pages/OrganizationListPage";
import SettingsScreen from "../../components/pages/SettingsScreen/SettingsScreen";
import StatisticsScreen from "../../components/pages/StatisticsScreen/StatisticsScreen";
import SupportScreen from "../../components/pages/SupportScreen/SupportScreen";
import UserManagementScreen from "../../components/pages/UserManagementScreen/UserManagementScreen";
import Spinner from "../../components/utils/Spinner/Spinner";
import AuthenticatedAppLoader from "./AuthenticatedAppLoader";

export default function buildAppRouter() {
  return createBrowserRouter([
    {
      path: "/",
      element: <LandingPageScreen />,
    },
    {
      path: "/app",
      element: <AuthenticatedAppLoader />,
      errorElement: <ErrorUnexpectedScreen message="Erreur lors du chargement de l'application" />,

      children: [
        {
          path: "",
          element: <HomeScreen />,
        },
        {
          path: "databases",
          children: [
            {
              path: "",
              element: <DatabaseListPage />,
            },
            {
              path: "create",
              element: <DatabaseCreateScreen />,
            },
            {
              path: ":databaseId/view",
              element: <DatabaseViewPage />,
            },
            {
              path: ":databaseId/tables/:tableId/view",
              element: <DatabaseViewPage />,
            },
            {
              path: ":databaseId/edit",
              element: <DatabaseEditScreen />,
            },
            {
              path: ":databaseId/tables/:tableId",
              element: <DatabaseDataListPage />,
            },
            {
              path: ":databaseId/tables/:tableId/create",
              element: <DatabaseDataCreatePage />,
            },
            {
              path: ":databaseId/tables/:tableId/data/:datumId/edit",
              element: <DatabaseDataEditPage />,
            },
            {
              path: "import",
              element: <ImportDataPage />,
            },
          ],
        },
        // FIXME: remove this at the end
        {
          path: "references",
          children: [
            {
              path: "",
              element: <ReferenceListScreen />,
            },
            {
              path: "create-data",
              element: <ReferenceDataCreateScreen />,
            },
            {
              path: ":referenceId/create-data",
              element: <ReferenceDataCreateScreen />,
            },
            {
              path: "data",
              element: <ReferenceDataListScreen />,
            },
            {
              path: ":referenceId/data",
              element: <ReferenceDataListScreen />,
            },
          ],
        },
        {
          path: "organizations",
          children: [
            {
              path: "",
              element: <OrganizationListPage />,
            },
            {
              path: "create",
              element: <OrganizationCreatePage />,
            },
            {
              path: ":organizationId/edit",
              element: <OrganizationEditPage />,
            },
          ],
        },
        {
          path: "journals",
          element: <JournalsScreen />,
        },
        {
          path: "statistics",
          element: <StatisticsScreen />,
        },
        {
          path: "settings",
          children: [
            {
              path: "",
              element: <SettingsScreen />,
            },
            {
              path: "users",
              element: (
                <Suspense fallback={<Spinner />}>
                  <UserManagementScreen />
                </Suspense>
              ),
            },
            {
              path: "developer",
              element: <DeveloperScreen />,
            },
          ],
        },
        {
          path: "support",
          element: <SupportScreen />,
        },
        {
          path: "*",
          element: <ErrorNotFoundScreen />,
        },
      ],
    },
  ]);
}
